interface BadgeProps {
  label: string
  variant: 'draft' | 'published' | 'cancelled' | 'completed' | 'success' | 'warning' | 'danger' | 'default'
}

const variants: Record<BadgeProps['variant'], string> = {
  draft:     'bg-gray-100 text-gray-600',
  published: 'bg-success-50 text-success-700 border border-success-200',
  cancelled: 'bg-danger-50 text-danger-700',
  completed: 'bg-primary-50 text-primary-700',
  success:   'bg-success-50 text-success-700',
  warning:   'bg-warning-50 text-warning-600',
  danger:    'bg-danger-50 text-danger-700',
  default:   'bg-gray-100 text-gray-600',
}

const labels: Record<string, string> = {
  draft:     'Brouillon',
  published: 'Publié',
  cancelled: 'Annulé',
  completed: 'Terminé',
}

export function Badge({ label, variant }: BadgeProps) {
  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold ${variants[variant]}`}>
      {labels[label] ?? label}
    </span>
  )
}
